<template>
    <AppDialog v-model="isOpen" size="lg" @close="onDialogClosed">
        <template #header>
            <h2 class="text-lg font-semibold text-theme-base">
                {{ title }}
            </h2>
        </template>

        <div class="space-y-4">
            <p v-if="!options.length" class="text-sm text-theme-muted">
                No hay planes disponibles.
            </p>
            <template v-else>
                <cards-selector v-model="selectedValue" :base="optionItems" />
                <p
                    v-if="selectedOption && selectedOption.warning"
                    class="text-sm text-theme-warning"
                >
                    {{ selectedOption.warning }}
                </p>
                <plan-benefits-list
                    v-if="selectedPlanCode"
                    :plan-code="selectedPlanCode"
                    :title="benefitsTitle"
                />
            </template>
        </div>

        <template #footer>
            <div class="flex flex-col sm:flex-row justify-end gap-2">
                <button
                    class="rounded-lg border border-theme-border px-4 py-2 text-sm font-medium text-theme-muted transition hover:bg-theme-hover"
                    @click="isOpen = false"
                >
                    Cancelar
                </button>
                <app-button
                    color="success"
                    :loading="loading"
                    :disabled="!selectedValue"
                    @click="confirm"
                >
                    {{ confirmLabel }}
                </app-button>
            </div>
        </template>
    </AppDialog>
</template>

<script>
import { planNameFromCode } from "@/common/fields/plan-features";

import AppDialog from "@/components/utils/AppDialog.vue";
import CardsSelector from "@/components/utils/CardSelector.vue";
import PlanBenefitsList from "@/components/utils/PlanBenefitsList.vue";

export default {
    name: "PlatformPlanSelectorDialog",
    components: { AppDialog, CardsSelector, PlanBenefitsList },
    model: {
        prop: "value",
        event: "input"
    },
    props: {
        value: {
            type: Boolean,
            default: false
        },
        // [{ value, label, hint, warning?, planCode? }]
        options: {
            type: Array,
            default: () => []
        },
        title: {
            type: String,
            default: "Elegir plan"
        },
        confirmLabel: {
            type: String,
            default: "Confirmar"
        },
        loading: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            selectedValue: null
        };
    },
    computed: {
        isOpen: {
            get() {
                return this.value;
            },
            set(value) {
                this.$emit("input", value);
            }
        },
        optionItems() {
            return this.options.map((option) => ({
                id: option.value,
                name: option.label,
                description: option.hint,
                icon: "🔷"
            }));
        },
        selectedOption() {
            return (
                this.options.find(
                    (option) => option.value === this.selectedValue
                ) || null
            );
        },
        selectedPlanCode() {
            return this.selectedOption && this.selectedOption.planCode
                ? this.selectedOption.planCode
                : null;
        },
        benefitsTitle() {
            return `${planNameFromCode(this.selectedPlanCode)} incluye:`;
        }
    },
    methods: {
        confirm() {
            if (!this.selectedOption) return;
            this.$emit("confirm", this.selectedOption);
        },
        onDialogClosed() {
            this.selectedValue = null;
        }
    }
};
</script>
